/* eslint-disable */
import { Select, Table, DatePicker, Tabs, Row, Flex,Radio } from "antd";
import { forwardRef, useEffect, useState, useRef } from "react";
import commonFn from "@/utils/commonFn";
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import {
  SyncOutlined,
} from "@ant-design/icons";
const { RangePicker } = DatePicker;

const MaintenceHistoryReport = forwardRef(() => {
  const [error, setError] = useState(null);
  const [rangeValue, setRangeValue] = useState(null);
  const [filteredReadyData, setFilteredReadyData] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("Ready To Pay");
  const activeTabKeyRef = useRef("Ready To Pay");
  const [tableLoading, setTableLoading] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const [timeDate, setTimeDate] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });

const handleTabChange = (key) => {
  setActiveTabKey(key);
  activeTabKeyRef.current = key;
  const newColumns = commonFn.handleColunmFn(getInitReadyColumns(key));
  setReadyColumns(newColumns);
};

  const handlReadyRequestClick = (record) => {
    if (record.requestCount === 0) {
      return;
    }

    const params = {
      ids: record.requestIds,
      statusFilter: activeTabKeyRef.current,
    };
    console.log("params,", params);
    const baseUrl = window.location.origin;
    const route = "/JobRequests/MaintenanceHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const handlReadyOverRequestCountClick = (record) => {
    if (record.overRequestCount === 0) {
      return;
    }

    const params = {
      ids: record.requestIds,
      statusFilter: activeTabKeyRef.current,
    };
    console.log("params,", params);
    const baseUrl = window.location.origin;
    const route = "/JobRequests/MaintenanceHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleDateChange = (dates, dateStrings) => {
    setRangeValue(dates);
    readyReportAllData(dateStrings[0], dateStrings[1]);
  };

  // 格式化 count
const formatCount = (count) => {
  if (count === null || count === undefined) return "-";
  return Number(count) === 0 ? "-" : count;
};

// 公共渲染函数
const renderCountCell = (text, record, handler) => {
  const value = formatCount(text);
  return (
    <span
      style={{
        color: value === "-" ? "inherit" : "#0e78a9",
        // textDecoration: value === "-" ? "none" : "underline",
        cursor: value === "-" ? "default" : "pointer",
      }}
      onClick={() => value !== "-" && handler(record)}
    >
      {value}
    </span>
  );
};

const getInitReadyColumns = (activeTabKey) => [
  {
    title: "Supervisor Name",
    dataIndex: "supervisorName",
    key: "supervisorName",
    hidden: false,
    width: 300,
    align: "center",
    isSorter: true,
    sortterMultiple: 2,
    render: (text) => text,
  },
  {
    title: "Total Requests",
    dataIndex: "requestCount",
    key: "requestCount",
    hidden: false,
    width: 200,
    align: "center",
 render: (text, record) => renderCountCell(text, record, handlReadyRequestClick),
  },
  // 仅在非 "Document Only" 选项卡时显示此列
  ...(activeTabKey !== "Document Only" ? [
    {
      title: "Overdue Requests",
      dataIndex: "overRequestCount",
      key: "overRequestCount",
      hidden: false,
      width: 300,
      align: "center",
    render: (text, record) => renderCountCell(text, record, handlReadyOverRequestCountClick),
    }
  ] : []),
];
  const [readyColumns, setReadyColumns] = useState(
  commonFn.handleColunmFn(getInitReadyColumns(activeTabKey))
);

  //获取ready to pay report
  const readyReportAllData = async (startTime, endTime) => {
    try {
      setTableLoading(true);
      const timestamps = getCurrentMonthRange(startTime, endTime);
      // console.log("时间范围:", timestamps);
      setTimeDate(timestamps);
      const params = {
        sCreateTime: timestamps.startTime || "",
        eCreateTime: timestamps.endTime || "",
      };
      const response = await http.get(`${api.getReadyReportHistoryList}`, { params });
      // 处理 ready 数据
      const readyDataWithKey = (response.data.ready || []).map((item) => ({
        ...item,
        key: item.accountId,
      }));
      // 处理 document 数据
      const documentDataWithKey = (response.data.document || []).map(
        (item) => ({
          ...item,
          key: item.accountId,
        })
      );
      console.log("数据获取:", readyDataWithKey, documentDataWithKey);
      setFilteredReadyData(readyDataWithKey);
      setDocumentData(documentDataWithKey);
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };
  const tabItems = [
    {
      key: "Ready To Pay",
      label: "Ready To Pay",
    },
    {
      key: "Document Only",
      label: "Document Only",
    },
  ];

  const getCurrentTableData = () => {
    return activeTabKey === "Ready To Pay" ? filteredReadyData : documentData;
  };

  // 处理分页变化
  const handleTableChange = (pagination, filters, sorter) => {
    console.log("页码更新");
    console.log(filters);
    //table筛选
    console.log("Sorter:", sorter); //可选值为 ['ascend'升序, 'descend'降序, undefined未选中] 或自定义顺序。
    console.log(pagination);
    readyReportAllData();
  };

  // 时间戳转化
  const getCurrentMonthRange = (startTime, endTime) => {
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0"); // 补零
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    const toTimestamp = (dateString) => {
      return new Date(dateString).getTime();
    };
    return {
      startTime: toTimestamp(formatDate(new Date(startTime))),
      endTime: toTimestamp(formatDate(new Date(endTime))),
    };
  };
    const showModalThree = () => {
    console.log("==========刷新按钮============");
   readyReportAllData()
  };

  // 初始化函数

  useEffect(() => {
      setRangeValue(null); 
    readyReportAllData();
  }, []);
  return (
    <div>
      <div style={{ marginTop: "10px" }}>
     

 <Flex className="topDiv" justify="space-between" align="flex-start">
        <div className="topLeft"> 
             <Tabs
          defaultActiveKey="Ready To Pay"
          items={tabItems}
          onChange={handleTabChange}
          style={{ marginBottom: 16 }}
        />

        <RangePicker
        value={rangeValue} 
          onChange={handleDateChange}
          format="YYYY-MM-DD"
          style={{ marginBottom: "20px" ,marginLeft:"20px",textAlign: "left"}}
        />
        </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>

        <Table
          rowClassName="table-row-gradient"
          loading={tableLoading}
          bordered={true}
          pagination={false}
          columns={readyColumns.filter((col) => col.hidden === false)}
          dataSource={getCurrentTableData()}
          rowKey="accountId"
          onChange={handleTableChange}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 350px)",
          }}
          className="maintabce-report-Table"
        />
      </div>
    </div>
  );
});
export default MaintenceHistoryReport;
